import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Container, MaskText, Reveal, Overline, LimeButton, ArrowDot, scrollToId, ease } from "./primitives";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="sobre" ref={ref} className="grain relative overflow-hidden bg-[#060B19] py-20 text-white lg:py-32" data-testid="about-section">
      <div className="font-display pointer-events-none absolute -right-10 top-10 select-none text-[22vw] font-extrabold leading-none tracking-[-0.05em] text-white/[0.03]">MR</div>
      <Container className="relative grid gap-14 lg:grid-cols-12 lg:items-center">
        <div className="relative lg:col-span-5">
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
          <motion.div variants={{ hidden: { clipPath: "inset(0% 100% 0% 0% round 28px)" }, show: { clipPath: "inset(0% 0% 0% 0% round 28px)", transition: { duration: 1.4, ease } } }}
            className="relative aspect-[4/5] overflow-hidden rounded-[28px]" data-testid="about-portrait">
            <motion.img src="/img/maicon.jpg" alt="Maicon Roberto" style={{ y, scale: 1.15 }} className="absolute inset-0 h-full w-full object-cover object-[30%_0%]" data-testid="about-portrait-img" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060B19]/50 to-transparent" />
          </motion.div>
          </motion.div>
          <Reveal delay={0.4} className="absolute -bottom-6 -right-2 sm:-right-6">
            <div className="rounded-[20px] bg-[#CCFF00] px-6 py-5 text-[#060B19] shadow-2xl" data-testid="about-badge">
              <div className="font-display text-5xl font-extrabold tracking-[-0.04em]">25+</div>
              <div className="text-xs font-bold uppercase tracking-wider">anos de experiência</div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Overline dark>Quem conduz</Overline>
          <MaskText className="font-display mt-6 text-5xl font-extrabold leading-[0.95] tracking-[-0.04em] sm:text-7xl"
            lines={["Maicon", <span className="text-[#CCFF00]">Roberto.</span>]} />
          <Reveal>
            <div className="font-mono-x mt-6 text-xs uppercase tracking-[0.2em] text-slate-300">Consultor de Estratégia, Marketing e Vendas</div>
            <p className="mt-6 text-base leading-relaxed text-slate-300 md:text-lg">
              [placeholder] Com mais de 25 anos de experiência em estratégia, marketing e vendas, Maicon Roberto acumula projetos em diferentes setores do mercado. Sua atuação vai da construção de planos personalizados à implementação de estratégias de alto impacto, sempre com foco em resultados concretos.
            </p>
            <LimeButton className="mt-10" onClick={() => scrollToId("contato")} data-testid="about-cta">Conversar com Maicon <ArrowDot /></LimeButton>
          </Reveal>
        </div>
      </Container>
    </section>
  );
};
